function Badge() {
    return (
        <div className="row tall-row">
            <div className="col-lg-12">
                <p>
                    <img src="https://projecteuler.net/profile/AchrafS.png" alt="Banner" title="Euler Project Badge" />
                </p>
            </div>
        </div>
    );
}

export default Badge;